import AbstractButton from './Button';
export const commonButtonPropTypes = AbstractButton.propTypes;
export default AbstractButton;
